var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useTable, useExpanded, usePagination, useSortBy } from "react-table";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { configDataConstants, ordersConstants } from "../store/actions/types";
import ProductsTable from "./ProductsTable";
import dropDownIcon from "../assets/icons/drop-down.svg";
import toast from "react-hot-toast";
import { deleteOrder, patchOrder } from "../utils/ordersApi";
import confirmAction from "../utils/confirmAction";
import editIcon from "../assets/icons/edit.svg";
import deleteIcon from "../assets/icons/delete.svg";
import addIcon from "../assets/icons/add.svg";
import { formatDateTime } from "../utils/formatDateTime";
import ReactTooltip from "react-tooltip";
import { ConfData3 as meetingTables } from "../const/meetingTables";
import { ConfData3 as confTables } from "../const/conferenceTables";
import { ConfData3 as workStation } from "../const/const";
import { ConfData3 as discussion } from "../const/discussionTables";
import { ConfData3 as cabinTable } from "../const/cabinTablesNew";
import { ConfData3 as neoWorkstation } from "../const/neoWorkstations";
import { makeSessionRequest } from "../utils/makeSessionRequest";
function Table({ columns, data, editOrder, showGenerateQuotationForm, showBomDownloadForm }) {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const totalOrders = useAppSelector((state) => state.orders.totalOrders);
    const currentPage = useAppSelector((state) => state.orders.currentPage);
    const currentPageSize = useAppSelector((state) => state.orders.pageSize);
    const user = useAppSelector((state) => state.user);
    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, visibleColumns, 
    // canPreviousPage,
    // canNextPage,
    // pageOptions,
    // pageCount,
    // gotoPage,
    // nextPage,
    // previousPage,
    setPageSize, page,
    // state: { pageIndex, pageSize },
     } = useTable({
        columns,
        data,
        initialState: {
            pageIndex: 0,
            pageSize: currentPageSize,
            // sortBy: [{ id: "createdAt", desc: true }],
        },
        autoResetExpanded: false,
        autoResetPage: false,
    }, useSortBy, useExpanded, usePagination);
    const addProduct = (order) => {
        makeSessionRequest("clicked_on_add_product", { orderId: order._id });
        if (order.cart_items.length > 0) {
            let tableType = order.cart_items[0].configuration.type;
            tableType =
                tableType.includes("main partition") ||
                    tableType.includes("main + return partition")
                    ? "Neo WKS"
                    : tableType;
            if (tableType === "Meeting Table") {
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: meetingTables,
                });
            }
            else if (tableType === "Conference Table") {
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: confTables,
                });
            }
            else if (tableType === "Discussion Table") {
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: discussion,
                });
            }
            else if (tableType === "Cabin Table") {
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: cabinTable,
                });
            }
            else if (tableType === "Neo WKS") {
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: neoWorkstation,
                });
            }
            else {
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: workStation,
                });
            }
        }
        dispatch({ type: ordersConstants.SET_CURRENT_ORDER, payload: order });
        history.push("/configurator");
    };
    const removeOrder = (order) => __awaiter(this, void 0, void 0, function* () {
        try {
            order._id && (yield deleteOrder(order._id));
            dispatch({ type: ordersConstants.DELETE_ORDER, payload: order });
            toast.success("Order deleted successfully");
            makeSessionRequest("order_deleted", { orderId: order._id });
        }
        catch (error) {
            toast.error("Error deleting order");
        }
    });
    const removeOrderConfirm = (order) => {
        confirmAction("Confirm Delete", "", () => removeOrder(order));
    };
    const handleBomClick = (order) => __awaiter(this, void 0, void 0, function* () {
        makeSessionRequest("clicked_quote", {
            orderId: order._id,
            customerName: order.customer.name,
        });
        showGenerateQuotationForm();
        dispatch({ type: ordersConstants.SET_CURRENT_ORDER, payload: order });
    });
    const lastPage = totalOrders % 10 > 0
        ? Math.floor(Number(totalOrders / currentPageSize)) + 1
        : Math.floor(Number(totalOrders / currentPageSize));
    const handleNextClick = () => {
        const nextPage = currentPage + 1;
        if (nextPage <= lastPage) {
            dispatch({
                type: ordersConstants.SET_CURRENT_PAGE,
                payload: nextPage,
            });
        }
        else {
            return;
        }
    };
    const handlePrevClick = () => {
        const prevPage = currentPage - 1;
        if (prevPage >= 1) {
            dispatch({
                type: ordersConstants.SET_CURRENT_PAGE,
                payload: prevPage,
            });
        }
        else {
            return;
        }
    };
    return (_jsxs("div", Object.assign({ className: " shadow-xl" }, { children: [_jsxs("table", Object.assign({}, getTableProps(), { className: "w-full" }, { children: [_jsx("thead", { children: headerGroups.map((headerGroup) => (_jsx("tr", Object.assign({ className: " border-0 border-b-2 text-left xl:text-xl" }, headerGroup.getHeaderGroupProps(), { children: headerGroup.headers.map((column) => (_jsx("th", Object.assign({ className: "p-4 md:pr-10 md:pl-0 px-2" }, column.getHeaderProps(), { children: column.render("Header") })))) })))) }), _jsxs("tbody", Object.assign({}, getTableBodyProps(), { children: [page.map((row, i) => {
                                prepareRow(row);
                                const rowProps = row.getRowProps();
                                return (_jsxs(React.Fragment, { children: [_jsxs("tr", Object.assign({ className: " border-0 border-t" }, rowProps, { children: [row.cells.map((cell) => {
                                                    return (_jsx("td", Object.assign({ className: "py-2 xl:text-xl" }, cell.getCellProps(), { children: cell.render("Cell") })));
                                                }), user.role !== 3 && (_jsx("td", { children: _jsx("button", Object.assign({ onClick: () => handleBomClick(row.original), className: `${row.original.cart_items.length === 0
                                                            ? "opacity-30 pointer-events-none"
                                                            : ""} underline font-bold ml-4 xl:text-lg` }, { children: "Quote" })) })), _jsx("td", { children: _jsx("img", { src: addIcon, className: "cursor-pointer mx-4", alt: "", onClick: () => addProduct(row.original) }) }), _jsx("td", { children: _jsx("img", { src: editIcon, className: "cursor-pointer mr-4", alt: "", onClick: () => editOrder(row.original) }) }), _jsx("td", { children: _jsx("img", { src: deleteIcon, onClick: () => removeOrderConfirm(row.original), className: "cursor-pointer mr-4", alt: "" }) })] })), row.isExpanded ? (_jsx("tr", { children: _jsx("td", Object.assign({ colSpan: visibleColumns.length }, { children: _jsx("div", Object.assign({ className: "m-4 flex justify-center" }, { children: _jsx(ProductsTable, { order: row.original }) })) })) })) : null] }, rowProps.key));
                            }), _jsx("tr", {})] }))] })), _jsxs("div", Object.assign({ className: "pagination mt-4 p-4" }, { children: [_jsx("button", Object.assign({ className: "border px-2 rounded-lg", onClick: () => dispatch({
                            type: ordersConstants.SET_CURRENT_PAGE,
                            payload: 1,
                        }) }, { children: "<<" })), " ", _jsx("button", Object.assign({ className: "border px-2 rounded-lg", onClick: () => handlePrevClick() }, { children: "<" })), " ", _jsx("button", Object.assign({ className: "border px-2 rounded-lg", onClick: () => handleNextClick() }, { children: ">" })), " ", _jsx("button", Object.assign({ className: "border px-2 rounded-lg", onClick: () => dispatch({
                            type: ordersConstants.SET_CURRENT_PAGE,
                            payload: lastPage,
                        }) }, { children: ">>" })), " ", _jsxs("span", { children: ["Page", " ", _jsxs("strong", { children: [currentPage, " of ", lastPage] }), " "] }), _jsxs("span", { children: ["| Go to page:", " ", _jsx("input", { className: "border p-1 px-2 focus:outline-none", type: "number", min: 1, max: lastPage, defaultValue: currentPage, onChange: (e) => {
                                    const page = e.target.value ? Number(e.target.value) : 1;
                                    dispatch({
                                        type: ordersConstants.SET_CURRENT_PAGE,
                                        payload: page,
                                    });
                                }, style: { width: "100px" } })] }), " ", _jsx("select", Object.assign({ className: "border p-1 focus:outline-none", value: currentPageSize, onChange: (e) => {
                            setPageSize(Number(e.target.value));
                            dispatch({
                                type: ordersConstants.SET_PAGE_SIZE,
                                payload: Number(e.target.value),
                            });
                        } }, { children: [10, 20, 30, 40].map((pageSize) => (_jsxs("option", Object.assign({ value: pageSize }, { children: ["Show ", pageSize] }), pageSize))) }))] }))] })));
}
function OrdersTable({ editOrder, showGenerateQuotationForm, showBomDownloadForm }) {
    const orders = useAppSelector((state) => state.orders.orders);
    const searchedOrders = useAppSelector((state) => state.orders.searchedOrders);
    const dispatch = useAppDispatch();
    const changeStatus = useCallback((order, status) => {
        const updatedOrder = JSON.parse(JSON.stringify(order));
        updatedOrder.status.status = status;
        patchOrder(updatedOrder)
            .then((data) => {
            dispatch({
                type: ordersConstants.UPDATE_ORDER,
                payload: updatedOrder,
            });
            toast.success("Product updated successfully");
        })
            .catch((error) => {
            toast.error("Error updating product");
        });
    }, [dispatch]);
    const columns = React.useMemo(() => [
        {
            Header: () => null,
            id: "expander",
            Cell: ({ row }) => (_jsx("span", Object.assign({}, row.getToggleRowExpandedProps(), { children: _jsx("img", { className: `transform transition-transform ml-auto px-4 ${row.isExpanded ? "rotate-180" : ""} `, src: dropDownIcon, alt: "" }) }))),
        },
        {
            Header: () => _jsx("span", Object.assign({ className: "mx-0" }, { children: "ID" })),
            id: "index",
            Cell: ({ row }) => {
                var _a;
                return (_jsx("span", Object.assign({ "data-tip": row.original._id, className: " cursor-pointer" }, { children: (_a = row.original._id) === null || _a === void 0 ? void 0 : _a.slice(row.original._id.length - 4, row.original._id.length) })));
            },
        },
        {
            Header: "Company Name",
            // accessor: "customerName",
            Cell: ({ row }) => {
                var _a;
                return (_jsxs("span", Object.assign({ className: "mx-4" }, { children: [_jsx(ReactTooltip, {}), ((_a = row.original.custom_data) === null || _a === void 0 ? void 0 : _a.company_name) ||
                            row.original.customer.name] })));
            },
        },
        {
            Header: "POC's Email",
            // accessor: "customerEmail",
            Cell: ({ row }) => (_jsxs("span", Object.assign({ className: "mx-4" }, { children: [_jsx(ReactTooltip, {}), row.original.customer.email] }))),
        },
        {
            Header: "Location",
            // accessor: "customerEmail",
            Cell: ({ row }) => (_jsxs("span", Object.assign({ className: "" }, { children: [_jsx(ReactTooltip, {}), row.original.customer.location
                        ? row.original.customer.location
                        : ""] }))),
        },
        {
            Header: "SalesForce Id",
            // accessor: "salesForceId",
            Cell: ({ row }) => (_jsxs("span", Object.assign({ className: "mx-4" }, { children: [_jsx(ReactTooltip, {}), row.original.lead_id] }))),
        },
        {
            Header: "Created at",
            Cell: ({ row }) => formatDateTime(row.original.created_at),
            accessor: "createdAt",
        },
        {
            Header: () => _jsx("span", Object.assign({ className: "mx-4" }, { children: "Status" })),
            id: "expander1",
            Cell: ({ row }) => (_jsxs("span", Object.assign({ className: "mx-4" }, { children: [_jsx(ReactTooltip, {}), _jsxs("select", Object.assign({ className: " cursor-pointer", "data-tip": row.original.status.status === 2
                            ? row.original.status.description
                            : null, name: "status", value: row.original.status.status, onChange: (e) => changeStatus(row.original, parseInt(e.target.value)), id: "" }, { children: [_jsx("option", Object.assign({ value: "0" }, { children: "New" })), _jsx("option", Object.assign({ value: "1" }, { children: "Received" })), _jsx("option", Object.assign({ value: "2" }, { children: "Lost" }))] }))] }))),
        },
    ], [changeStatus]);
    if (searchedOrders.length > 0) {
        return (_jsx(Table, { columns: columns, data: searchedOrders, editOrder: editOrder, showGenerateQuotationForm: showGenerateQuotationForm, showBomDownloadForm: showBomDownloadForm }));
    }
    else {
        return (_jsx(Table, { columns: columns, data: orders, editOrder: editOrder, showGenerateQuotationForm: showGenerateQuotationForm, showBomDownloadForm: showBomDownloadForm }));
    }
}
export default OrdersTable;
